function downloadAsCsv(dataArray, fileName) {
  let csvContent =
    'data:text/csv;charset=utf-8,sep=,\n' +
    dataArray
      .map(line => line.map(item => `"${item}"`.replace('#', 'id')).join(','))
      .join('\n')

  const encodedUri = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', fileName)
  document.body.appendChild(link) // Required for FF

  link.click() // This will download the data file named "my_data.csv".
}

export default downloadAsCsv
